import { ProjectsActionType } from './enums';
import { ProjectsAction, ProjectsState } from './interfaces';

export const initialState: ProjectsState = {
	error: null,
	loading: false,
	projectsList: [],
	totalRecords: 0,
	projectDetails: {},
	projectDetailsLoading: false,
	projectDetailsError: null,
	autoSuggestCollaborate: [],
	autoSuggestCollaborateError: {},
	autoSuggestAssignee: [],
	autoSuggestAssigneeError: {},
	autoSuggestLeadDesigner: [],
	autoSuggestLeadDesignerError: {},
	projectActivities: [],
	projectActivitiesError: { code: '', message: '', type: '' },
	projectActivitiesLoading: false,
	allApprovals: [],
	allApprovalTotalRecords: 0,
	allApprovalsLoading: false,
	allApprovalsError: { code: '', message: '', type: '' },
	projectActivityDocuments: [],
	projectActivityDocumentsError: { code: '', message: '', type: '' },
	projectActivityDocumentsLoading: false,
	approvalDocuments: [],
	approvalDocumentsLoading: false,
	approvalDocumentsError: {
		code: '',
		message: '',
		type: ''
	},
	ledgerData: {},
	ledgerDataLoading: false,
	ledgerDataError: { code: '', message: '', type: '' },
	projectDiscounts: {},
	projectDiscountsLoading: false,
	projectDiscountsError: { code: '', message: '', type: '' },
	floorPlanImage: [],
	floorPlanImageError: { code: '', message: '', type: '' },
	floorPlanImageLoading: false,
	ordersListLoading: false,
	ordersList: [],
	ordersListTotalRecords: 0,
	ordersListError: undefined,
	assigneeDropdown: [],
	assigneeDropdownLoading: false,
	designerDropdown: [],
	designerDropdownLoading: false,
	productionDropdown: [],
	productionDropdownLoading: false,
	qcDropdown: [],
	qcDropdownLoading: false,
	assignees: [],
	warrantyClaims: [],
	warrantyClaimsLoading: false,
	warrantyClaimsError: { code: '', message: '', type: '' },
	warrantyClaimsTotalRecords: 0,
	warrantyClaimDetails: null,
	warrantyClaimDetailsLoading: false,
	warrantyClaimDetailsError: { code: '', message: '', type: '' },
	warrantyDocuments: [],
	warrantyDocumentsLoading: false,
	warrantyDocumentsError: { code: '', message: '', type: '' },
	financeDropdown: [],
	financeDropdownLoading: false,
	procurementDropdown: [],
	procurementDropdownLoading: false,
	manufacturingDropdown: [],
	manufacturingDropdownLoading: false,
	projectManagementDropdown: [],
	projectManagementDropdownLoading: false,
	projectWarranty: null,
	projectWarrantyLoading: false,
	projectWarrantyError: { code: '', message: '', type: '' },
	descopeApprovals: [],
	descopeApprovalsLoading: false,
	descopeApprovalsError: { code: '', message: '', type: '' },
	descopeApprovalsTotalRecords: 0,
	optimiserData: null,
	optimiserDataLoading: false,
	optimiserDataError: null
};

export default (state = initialState, { type, payload }: ProjectsAction): ProjectsState => {
	switch (type) {
		case ProjectsActionType.FETCH_PROJECTS: {
			return {
				...state,
				loading: true
			};
		}
		case ProjectsActionType.STORE_PROJECTS: {
			return {
				...state,
				loading: false,
				projectsList: payload.projectsList,
				totalRecords: payload.totalRecords
			};
		}
		case ProjectsActionType.ERROR_FETCH_PROJECTS: {
			return {
				...state,
				loading: false,
				error: payload.error
			};
		}

		case ProjectsActionType.FETCH_PROJECT_ACTIVITIES: {
			return {
				...state,
				projectActivitiesLoading: true,
				projectActivitiesError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_PROJECT_ACTIVITIES: {
			return {
				...state,
				projectActivitiesLoading: false,
				projectActivities: payload
			};
		}

		case ProjectsActionType.ERROR_PROJECT_ACTIVITIES: {
			return {
				...state,
				projectActivitiesLoading: false,
				projectActivitiesError: payload.error
			};
		}

		case ProjectsActionType.FETCH_PROJECT_DETAILS: {
			return {
				...state,
				projectDetails: {},
				projectDetailsLoading: true,
				projectDetailsError: {}
			};
		}

		case ProjectsActionType.STORE_PROJECT_DETAILS: {
			return {
				...state,
				projectDetailsLoading: false,
				projectDetails: payload?.data
			};
		}

		case ProjectsActionType.ERROR_FETCH_PROJECTS_DETAILS: {
			return {
				...state,
				projectDetailsLoading: false,
				projectDetailsError: payload.error
			};
		}

		case ProjectsActionType.STORE_AUTOCOMPLETE_LEAD_DESIGNER: {
			return {
				...state,
				autoSuggestLeadDesigner: payload
			};
		}

		case ProjectsActionType.STORE_COLLABORATOR_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestCollaborate: payload.data
			};
		}

		case ProjectsActionType.ERROR_FETCH_COLLABORATOR_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestCollaborateError: payload.error
			};
		}

		case ProjectsActionType.STORE_ASSIGNEE_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestAssignee: payload.data
			};
		}

		case ProjectsActionType.ERROR_FETCH_ASSIGNEE_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestAssigneeError: payload.error
			};
		}

		case ProjectsActionType.FETCH_ALL_APPROVAL: {
			return {
				...state,
				allApprovalsLoading: true,
				allApprovalsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_ALL_APPROVAL: {
			return {
				...state,
				allApprovalsLoading: false,
				allApprovals: payload.approvalList,
				allApprovalTotalRecords: payload.totalRecords
			};
		}

		case ProjectsActionType.ERROR_ALL_APPROVAL: {
			return {
				...state,
				allApprovalsLoading: false,
				allApprovalsError: payload.error
			};
		}

		case ProjectsActionType.FETCH_WARRANTY_CLAIMS: {
			return {
				...state,
				warrantyClaims: [],
				warrantyClaimsLoading: true,
				warrantyClaimsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_WARRANTY_CLAIMS: {
			return {
				...state,
				warrantyClaimsLoading: false,
				warrantyClaims: payload.warrantyClaims,
				warrantyClaimsTotalRecords: payload.totalRecords
			};
		}

		case ProjectsActionType.ERROR_WARRANTY_CLAIMS: {
			return {
				...state,
				warrantyClaimsLoading: false,
				warrantyClaimsError: payload.error
			};
		}

		case ProjectsActionType.FETCH_WARRANTY_CLAIM_BY_ID: {
			return {
				...state,
				warrantyClaimDetails: null,
				warrantyClaimDetailsLoading: true,
				warrantyClaimDetailsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_WARRANTY_CLAIM_DETAILS: {
			return {
				...state,
				warrantyClaimDetailsLoading: false,
				warrantyClaimDetails: payload
			};
		}

		case ProjectsActionType.ERROR_WARRANTY_CLAIM_DETAILS: {
			return {
				...state,
				warrantyClaimDetailsLoading: false,
				warrantyClaimDetailsError: payload.error
			};
		}

		case ProjectsActionType.FETCH_WARRANTY_DOCUMENTS: {
			return {
				...state,
				warrantyDocuments: [],
				warrantyDocumentsLoading: true,
				warrantyDocumentsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_WARRANTY_DOCUMENTS: {
			return {
				...state,
				warrantyDocumentsLoading: false,
				warrantyDocuments: payload
			};
		}

		case ProjectsActionType.FETCH_ACTIVITY_DOCUMENTS: {
			return {
				...state,
				projectActivityDocuments: [],
				projectActivityDocumentsLoading: true,
				projectActivityDocumentsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_ACTIVITY_DOCUMENTS: {
			return {
				...state,
				projectActivityDocumentsLoading: false,
				projectActivityDocuments: payload
			};
		}

		case ProjectsActionType.ERROR_FETCH_ACTIVITY_DOCUMENTS: {
			return {
				...state,
				projectActivityDocumentsLoading: false,
				projectActivityDocumentsError: payload.error
			};
		}

		case ProjectsActionType.FETCH_FLOOR_PLAN_IMAGE: {
			return {
				...state,
				floorPlanImage: [],
				floorPlanImageLoading: true,
				floorPlanImageError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_FLOOR_PLAN_IMAGE: {
			return {
				...state,
				floorPlanImageLoading: false,
				floorPlanImage: payload
			};
		}

		case ProjectsActionType.ERROR_FLOOR_PLAN_IMAGE: {
			return {
				...state,
				floorPlanImageLoading: false,
				floorPlanImageError: payload.error
			};
		}

		case ProjectsActionType.RESET_ACTIVITY_DOCUMENTS: {
			return {
				...state,
				projectActivityDocuments: [],
				projectActivityDocumentsLoading: false,
				projectActivityDocumentsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.FETCH_APPROVAL_DOCUMENTS: {
			return {
				...state,
				approvalDocumentsLoading: true,
				approvalDocumentsError: {
					code: '',
					message: '',
					type: ''
				}
			};
		}

		case ProjectsActionType.STORE_APPROVAL_DOCUMENTS: {
			return {
				...state,
				approvalDocumentsLoading: false,
				approvalDocuments: payload
			};
		}

		case ProjectsActionType.ERROR_APPROVAL_DOCUMENTS: {
			return {
				...state,
				approvalDocumentsLoading: false,
				approvalDocumentsError: payload.error
			};
		}

		case ProjectsActionType.FETCH_LEDGER_DATA: {
			return {
				...state,
				ledgerDataLoading: true,
				ledgerData: {},
				ledgerDataError: {
					code: '',
					message: '',
					type: ''
				}
			};
		}

		case ProjectsActionType.STORE_LEDGER_DATA: {
			return {
				...state,
				ledgerDataLoading: false,
				ledgerData: payload
			};
		}

		case ProjectsActionType.ERROR_LEDGER_DATA: {
			return {
				...state,
				ledgerDataLoading: false,
				ledgerDataError: payload.error
			};
		}

		case ProjectsActionType.FETCH_PROJECT_DISCOUNTS: {
			return {
				...state,
				projectDiscountsLoading: true,
				projectDiscountsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_PROJECT_DISCOUNTS: {
			return {
				...state,
				projectDiscountsLoading: false,
				projectDiscounts: payload
			};
		}

		case ProjectsActionType.ERROR_PROJECT_DISCOUNTS: {
			return {
				...state,
				projectDiscountsLoading: false,
				projectDiscountsError: payload.error
			};
		}

		case ProjectsActionType.FETCH_ORDERS: {
			return {
				...state,
				ordersListLoading: true,
				ordersListError: null
			};
		}

		case ProjectsActionType.STORE_ORDERS: {
			return {
				...state,
				ordersListLoading: false,
				ordersList: payload.projectsList,
				ordersListTotalRecords: payload.totalRecords
			};
		}

		case ProjectsActionType.ERROR_FETCH_ORDERS: {
			return {
				...state,
				ordersListLoading: false,
				ordersListError: payload.error
			};
		}

		case ProjectsActionType.FETCH_ASSIGNEE_DROPDOWN: {
			return {
				...state,
				assigneeDropdown: [],
				assigneeDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_ASSIGNEE_DROPDOWN: {
			return {
				...state,
				assigneeDropdown: payload?.users,
				assigneeDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_ASSIGNEE_DROPDOWN: {
			return {
				...state,
				assigneeDropdownLoading: false
			};
		}

		case ProjectsActionType.FETCH_DESIGNER_DROPDOWN: {
			return {
				...state,
				designerDropdown: [],
				designerDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_DESIGNER_DROPDOWN: {
			return {
				...state,
				designerDropdown: payload?.users,
				designerDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_DESIGNER_DROPDOWN: {
			return {
				...state,
				designerDropdownLoading: false
			};
		}

		case ProjectsActionType.FETCH_PRODUCTION_DROPDOWN: {
			return {
				...state,
				productionDropdown: [],
				productionDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_PRODUCTION_DROPDOWN: {
			return {
				...state,
				productionDropdown: payload?.users,
				productionDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_PRODUCTION_DROPDOWN: {
			return {
				...state,
				productionDropdownLoading: false
			};
		}

		case ProjectsActionType.FETCH_QC_DROPDOWN: {
			return {
				...state,
				qcDropdown: [],
				qcDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_QC_DROPDOWN: {
			return {
				...state,
				qcDropdown: payload?.users,
				qcDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_QC_DROPDOWN: {
			return {
				...state,
				qcDropdownLoading: false
			};
		}

		case ProjectsActionType.ADD_DISCOUNT: {
			return {
				...state,
				ledgerDataLoading: true,
				ledgerDataError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_PROJECT_ASSIGNEES: {
			return {
				...state,
				assignees: payload
			};
		}

		case ProjectsActionType.ERROR_PROJECT_ASSIGNEES: {
			return {
				...state,
				assignees: []
			};
		}

		case ProjectsActionType.FETCH_FINANCE_DROPDOWN: {
			return {
				...state,
				financeDropdown: [],
				financeDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_FINANCE_DROPDOWN: {
			return {
				...state,
				financeDropdown: payload?.users,
				financeDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_FINANCE_DROPDOWN: {
			return {
				...state,
				financeDropdownLoading: false
			};
		}

		case ProjectsActionType.FETCH_PROCUREMENT_DROPDOWN: {
			return {
				...state,
				procurementDropdown: [],
				procurementDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_PROCUREMENT_DROPDOWN: {
			return {
				...state,
				procurementDropdown: payload?.users,
				procurementDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_PROCUREMENT_DROPDOWN: {
			return {
				...state,
				procurementDropdownLoading: false
			};
		}

		case ProjectsActionType.FETCH_MANUFACTURING_DROPDOWN: {
			return {
				...state,
				manufacturingDropdown: [],
				manufacturingDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_MANUFACTURING_DROPDOWN: {
			return {
				...state,
				manufacturingDropdown: payload?.users,
				manufacturingDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_MANUFACTURING_DROPDOWN: {
			return {
				...state,
				manufacturingDropdownLoading: false
			};
		}

		case ProjectsActionType.FETCH_PROJECT_MANAGEMENT_DROPDOWN: {
			return {
				...state,
				projectManagementDropdown: [],
				projectManagementDropdownLoading: true
			};
		}

		case ProjectsActionType.STORE_PROJECT_MANAGEMENT_DROPDOWN: {
			return {
				...state,
				projectManagementDropdown: payload?.users,
				projectManagementDropdownLoading: false
			};
		}

		case ProjectsActionType.ERROR_FETCH_PROJECT_MANAGEMENT_DROPDOWN: {
			return {
				...state,
				projectManagementDropdownLoading: false
			};
		}

		case ProjectsActionType.FETCH_PROJECT_WARRANTY: {
			return {
				...state,
				projectWarranty: null,
				projectWarrantyLoading: true,
				projectWarrantyError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_PROJECT_WARRANTY: {
			return {
				...state,
				projectWarrantyLoading: false,
				projectWarranty: payload
			};
		}

		case ProjectsActionType.ERROR_PROJECT_WARRANTY: {
			return {
				...state,
				projectWarrantyLoading: false,
				projectWarrantyError: payload.error
			};
		}

		case ProjectsActionType.FETCH_DESCOPE_APPROVALS: {
			return {
				...state,
				descopeApprovals: [],
				descopeApprovalsLoading: true,
				descopeApprovalsError: { code: '', message: '', type: '' }
			};
		}

		case ProjectsActionType.STORE_DESCOPE_APPROVALS: {
			return {
				...state,
				descopeApprovalsLoading: false,
				descopeApprovals: payload.descopeApprovals,
				descopeApprovalsTotalRecords: payload.totalRecords
			};
		}

		case ProjectsActionType.ERROR_DESCOPE_APPROVALS: {
			return {
				...state,
				descopeApprovalsLoading: false,
				descopeApprovalsError: payload.error
			};
		}

		case ProjectsActionType.FETCH_OPTIMIZED_CUTLIST_DATA: {
			return {
				...state,
				optimiserData: null,
				optimiserDataLoading: true,
				optimiserDataError: null
			};
		}

		case ProjectsActionType.STORE_OPTIMIZED_CUTLIST_DATA: {
			return {
				...state,
				optimiserData: payload?.data?.data ?? payload?.data,
				optimiserDataLoading: false,
				optimiserDataError: null
			};
		}

		case ProjectsActionType.ERROR_OPTIMIZED_CUTLIST_DATA: {
			return {
				...state,
				optimiserDataLoading: false,
				optimiserDataError: payload?.error ?? payload
			};
		}

		default:
			return state;
	}
};
